import { COUNTRY_BE } from "../constants/CountryConstants";

/**
 * Check if house number is a number and doesnt contain a dot
 * @param houseNumber
 * @returns {boolean}
 */
export const validateHouseNumber = (houseNumber) => {
  return (
    !isNaN(houseNumber) &&
    houseNumber.indexOf(".") === -1 &&
    houseNumber.length <= 5
  );
};

export const validateZipCode = (zipCode, countryCode) => {
  if (countryCode === COUNTRY_BE) {
    let regex = /^[1-9][0-9]{3}$/i;
    return regex.test(zipCode);
  } else {
    let regex = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
    return regex.test(zipCode);
  }
};

/**
 * Check if addition is 2 characters, only letters and numbers
 * @param addition
 * @returns {boolean}
 */
export const validateAddition = (addition) => {
  if (addition === null) return true;
  let regex = /^[A-Z0-9]{0,2}$/i;
  return regex.test(addition) || typeof addition === "undefined";
};
